import * as actionTypes from '../actions/actionTypes';

const initialState = {
    searchCriteria: null,
    searchResults: null,
    loading: false,
    error: null,
    displayMessage: null,
    idType: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.START_SEARCH:
            return {
                ...state,
                loading: true,
                error: null,
                searchCriteria: action.searchCriteria,
                displayMessage: null
            }
        case actionTypes.RESET_SEARCH_RESULT:
            return {
                ...initialState
            }
        case actionTypes.SEARCH_USERS_SUCCESS:
            return {
                ...state,
                searchResults: action.response.payload,
                loading: false,
                error: action.response.status
            }
        case actionTypes.SEARCH_USERS_FAILED:
            // Promise.reject(action.error.response)
            return {
                ...state,
                loading: false,
                error: {message:"Oops!! Something didn't work. Pls try again."}
            }
        case actionTypes.SET_ERROR:
            return {
                ...state,
                error: action.error
            }
        case actionTypes.SEARCH_PAGE_MESSAGE:{
            return{
                ...state,
                displayMessage: action.message,
                // searchCriteria: null,
                searchResults:  null
            }
        }
        case actionTypes.RESET_SEARCH_INDICATORS:
            return {
                ...state,
                displayMessage: null,
                error: null
            }
        default:
            return state;
    }
}

export default reducer;
